import { ReactNode } from 'react'

import { dateStr, dateTimeStr, timeStr } from '@/common/util/date'

import Text, { TextColor } from '@/components/view/atoms/text/Text'

interface Props {
  list: {
    date: Date | string
    title: ReactNode
    message: ReactNode
  }[]
}

const History = ({ list }: Props) => {
  return (
    <ul className='border-tertiary relative ml-1 flex flex-col gap-2 border-l-2 py-2 pr-4 pl-2 placeholder-rose-100'>
      {list.map((item, index) => (
        <li key={index} className={'flex flex-col items-start gap-2 p-2'}>
          <span
            className={
              'border-surface bg-fill-brand absolute -left-[7px] h-3 w-3 rounded-lg border-2 content-[""]'
            }
          />
          <div className='flex items-center gap-2'>
            <Text size={12} color={TextColor.SECONDARY}>
              {dateTimeStr(item.date)}
            </Text>
            <p className='flex items-center gap-0.5'>{item.title}</p>
          </div>
          {item.message && (
            <div className='flex w-full items-start gap-2 pl-10'>{item.message}</div>
          )}
        </li>
      ))}
    </ul>
  )
}

export default History
